function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.71242 0.292021L5.59242 4.17202L9.47242 0.292021C9.565 0.199439 9.67491 0.125999 9.79587 0.0758944C9.91684 0.0257894 10.0465 9.75511e-10 10.1774 0C10.3083 -9.75506e-10 10.438 0.0257894 10.559 0.0758944C10.6799 0.125999 10.7898 0.199439 10.8824 0.292021C10.975 0.384603 11.0484 0.494513 11.0985 0.615478C11.1486 0.736442 11.1744 0.86609 11.1744 0.997021C11.1744 1.12795 11.1486 1.2576 11.0985 1.37856C11.0484 1.49953 10.975 1.60944 10.8824 1.70202L6.29242 6.29202C5.90242 6.68202 5.27242 6.68202 4.88242 6.29202L0.292418 1.70202C0.199715 1.60951 0.126167 1.49962 0.0759859 1.37864C0.0258045 1.25767 -2.57492e-05 1.12799 -2.57492e-05 0.997021C-2.57492e-05 0.866052 0.0258045 0.73637 0.0759859 0.615396C0.126167 0.494423 0.199715 0.384534 0.292418 0.292021C0.682419 -0.0879792 1.32242 -0.0979792 1.71242 0.292021Z",
  fill: "#2E7AE2"
});

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_down.4b466808.svg";
export { ForwardRef as ReactComponent };